import React from 'react';

const Loading = props => (
  <svg fill="#fff" {...props}>
    <circle cx={15} cy={15} r={5}>
      <animate
        attributeName="r"
        begin="0s"
        calcMode="linear"
        dur="0.8s"
        from={15}
        repeatCount="indefinite"
        to={15}
        values="5;2;5"
      />
      <animate
        attributeName="fill-opacity"
        begin="0s"
        calcMode="linear"
        dur="0.8s"
        from={1}
        repeatCount="indefinite"
        to={1}
        values="1;.5;1"
      />
    </circle>
    <circle cx={35} cy={15} fillOpacity={0.3} r={3}>
      <animate
        attributeName="r"
        begin="0s"
        calcMode="linear"
        dur="0.8s"
        from={9}
        repeatCount="indefinite"
        to={9}
        values="3;5;3"
      />
      <animate
        attributeName="fill-opacity"
        begin="0s"
        calcMode="linear"
        dur="0.8s"
        from={0.5}
        repeatCount="indefinite"
        to={0.5}
        values=".5;1;.5"
      />
    </circle>
    <circle cx={55} cy={15} r={5}>
      <animate
        attributeName="r"
        begin="0s"
        calcMode="linear"
        dur="0.8s"
        from={15}
        repeatCount="indefinite"
        to={15}
        values="5;2;5"
      />
      <animate
        attributeName="fill-opacity"
        begin="0s"
        calcMode="linear"
        dur="0.8s"
        from={1}
        repeatCount="indefinite"
        to={1}
        values="1;.5;1"
      />
    </circle>
  </svg>
);

export default Loading;
